export enum InvoiceStatus {
    Created = 1,
    Abandoned = 2,
    TermsAccepted = 3,
    Receivable = 4,
    Paid = 5,
    PaidReceivable = 6,
    WrittenOff = 7
}